import { ChangeDetectorRef, Component, inject, Inject, Input, OnInit, TemplateRef, ViewChild } from "@angular/core";
import { RestClient } from "../../../Api/DcoApi/Client/RestClient";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { Splash } from "../../../Akte/Controlls/Splash";
import { Geraete, GeraeteModell, KooperationsPartner, Leitstelle } from "../../../Api/DcoApi/Admin/AdminClasses2";
import { ToastService } from "../../../Akte/Services/Toasts/ToastService";
import { AdminCard } from "../Sonstige/AdminCard";
import { DateSelect } from "../../../Akte/Controlls/DateSelect";
import {DataGridView, DataGridViewCollumn, Types} from '../../../Componente/DataGridView';
import {PopUpView} from '../../../Componente/PopUpView';
import {StatusModel} from '../../../Api/DcoApi/Status/StatusModel';
import {AktePopup} from '../../../Main/Pages/Status/AktePopup';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap/modal';

@Component({
  imports: [
    CommonModule,
    Splash,
    DateSelect,
    FormsModule, AdminCard, DataGridViewCollumn, DataGridView, PopUpView
  ],
  selector: 'GeraeteEdit',
  templateUrl: './GeraeteEdit.html',
  standalone: true,
  styleUrl: './GeraeteEdit.css'
})
export class GeraeteEdit implements OnInit {
  toastService: ToastService;
  ngOnInit(): void {
    this.GetData();
  }

  constructor(private cdr: ChangeDetectorRef) {

    this.toastService = inject(ToastService)
  }

  Stati = [
    { Value: "Eigen", Key: 0 },
    { Value: "Fremd", Key: 1 },
    { Value: "Leasing", Key: 2 },
    { Value: "Mietmodell", Key: 2 },
    { Value: "Ratenkauf", Key: 2 },
  ];

  EigentumsArten = [
    { Value: "Lager", Key: 1 },
    { Value: "Versandvorbereitung ", Key: 7 },
    { Value: "Versand", Key: 2 },
    { Value: "Aktiv", Key: 3 },
    { Value: "Rücklauf", Key: 4 },
    { Value: "Defekt", Key: 5 },
    { Value: "Ausgesondert", Key: 6 }
  ];

  Typen = [
    { Key: 0, Value: "Basisstation" },
    { Key: 1, Value: "Funkknopf" },
    { Key: 2, Value: "Mobilgerät" }
  ]

  Partner: KooperationsPartner[] = [];
  Modelle: GeraeteModell[] = [];
  Leitstellen: Leitstelle[] = [];

  @Input() Key?: string | null = null;

  Client: RestClient = new RestClient();
  private modalService = inject(NgbModal);
  Entry: Geraete | null = null;

  OpenAkte(row: any) {
    var modal = this.modalService.open(AktePopup)
    modal.componentInstance.Key = row.auftragsID;
    modal.componentInstance.versichertenNr = row.versichertenNr;

  }

  async GetData() {
    if (!this.Key || this.Key == null || this.Key == "0" || isNaN(Number(this.Key)))
      this.Entry = {
        key: 0, finanzInfo: {}, model: {}, leitsetlle: {}, geraeteInfo: {}, partner: {}
      } as Geraete;
    else
      this.Entry = await this.Client.Get<Geraete>(`/Backend/Api/V2/Admin/Geraete/${this.Key}`);

    this.Partner = await this.Client.Get<KooperationsPartner[]>("/Backend/Api/V2/Admin/KooperationsPartner?PageSize=0")
    this.Modelle = await this.Client.Get<GeraeteModell[]>("/Backend/Api/V2/Admin/GeraeteModell?PageSize=0")
    this.Leitstellen = await this.Client.Get<Leitstelle[]>("/Backend/Api/V2/Admin/Leitstelle?PageSize=0")
    this.cdr.detectChanges();
  }

  async SaveData() {
    if (this.Entry && this.Entry !== null) {
      if (this.Entry.key == 0)
        this.Entry = await this.Client.Post<Geraete, Geraete>("/Backend/Api/V2/Admin/Geraete", this.Entry);
      else
        this.Entry = await this.Client.Put<Geraete, Geraete>(`/Backend/Api/V2/Admin/Geraete`, this.Entry);

      this.toastService.show({ template: this.successTpl, classname: 'bg-success text-light show', delay: 10000 })
      this.cdr.detectChanges();
    }
  }

  onPartnerChange(newKey: string | null): void {

    if (!this.Entry) {
      return;
    }


    if (!this.Entry.partner) {
      this.Entry.partner = {
        key: 0
      } as KooperationsPartner;
    }

    this.Entry.partner.key = Number(newKey);
  }

  @ViewChild('successTpl') public successTpl!: TemplateRef<any>;

  get BuchCalc(): string {
    if (!this.Entry || this.Entry == null)
      return "0";

    if (!this.Entry.finanzInfo || this.Entry.finanzInfo == null)
      this.Entry.finanzInfo = {}

    var abschreibungStart = !this.Entry.finanzInfo.abschreibungStart ? new Date() : new Date(this.Entry.finanzInfo.abschreibungStart);

    var initialBuchwert = !this.Entry.finanzInfo.initialBuchwert ? 0 : this.Entry.finanzInfo.initialBuchwert;
    var abschreibungDauerMonate = !this.Entry.finanzInfo.abschreibungDauerMonate ? 0 : this.Entry.finanzInfo.abschreibungDauerMonate;

    var tody = new Date();

    var monthsUsed = (tody.getFullYear() - abschreibungStart.getFullYear()) * 12 + (tody.getMonth() - abschreibungStart.getMonth());

    if ((tody.getMonth() > abschreibungStart.getMonth() && tody.getFullYear() == abschreibungStart.getFullYear()) || tody.getFullYear() >= abschreibungStart.getFullYear()) {
      monthsUsed = monthsUsed - 1;
    }

    if (monthsUsed < 0)
      monthsUsed = 0;
    if (monthsUsed > abschreibungDauerMonate)
      monthsUsed = abschreibungDauerMonate;

    var buchwertAktuell = initialBuchwert - (initialBuchwert / abschreibungDauerMonate) * monthsUsed;

    if (buchwertAktuell < 0)
      buchwertAktuell = 0;

    return buchwertAktuell.toFixed(2);
  }

  get LeaseCalc(): string {
    if (!this.Entry || this.Entry == null)
      return "0";

    if (!this.Entry.finanzInfo || this.Entry.finanzInfo == null)
      this.Entry.finanzInfo = {}

    var Start = !this.Entry.finanzInfo.lesingStart ? new Date() : new Date(this.Entry.finanzInfo.lesingStart);
    var Stop = !this.Entry.finanzInfo.lesingEnd ? new Date() : new Date(this.Entry.finanzInfo.lesingEnd);

    var tody = new Date();

    var reduce = true;

    if (Stop != null && Stop < tody) {
      tody = Stop;
        reduce = false;
      }

    var totalMonths = (Stop.getFullYear() - Start.getFullYear()) * 12 + (Stop.getMonth() - Start.getMonth());

      if (reduce)
        totalMonths = totalMonths - 1;

    var restPreis = (!this.Entry.finanzInfo.preis ? 0 : this.Entry.finanzInfo.preis) - (totalMonths * (!this.Entry.finanzInfo.rate ? 0 : this.Entry.finanzInfo.rate));

      if (restPreis < 0)
        restPreis = 0;

    return restPreis.toFixed(2);

  }

  protected readonly Types = Types;
}
